import { render, staticRenderFns } from "./ModuleStats.vue?vue&type=template&id=601a6388&"
import script from "./ModuleStats.vue?vue&type=script&lang=js&"
export * from "./ModuleStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports